// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Css = require("bs-css-emotion/src/Css.bs.js");
var CssJs = require("bs-css-emotion/src/CssJs.bs.js");
var Curry = require("@rescript/std/lib/js/curry.js");
var Belt_Option = require("@rescript/std/lib/js/belt_Option.js");
var Caml_option = require("@rescript/std/lib/js/caml_option.js");
var Type_Header = require("../../type/Type_Header.bs.js");
var Atom_Text_Ds = require("./Atom_Text_Ds.bs.js");
var Particle_Screen_Ds = require("../particle/Particle_Screen_Ds.bs.js");
var Particle_Spacer_Ds = require("../particle/Particle_Spacer_Ds.bs.js");
var Particle_Background_Ds = require("../particle/Particle_Background_Ds.bs.js");
var Particle_Screen_Constants = require("../particle/Particle_Screen_Constants.bs.js");

function getPredefinedHeight(t) {
  return Particle_Screen_Ds.map((function (shape) {
                if (typeof shape === "number") {
                  return ;
                } else {
                  return shape._0;
                }
              }), t.shape);
}

function getPredefinedWidth(t) {
  return Particle_Screen_Ds.map((function (shape) {
                if (typeof shape === "number") {
                  return ;
                }
                switch (shape.TAG | 0) {
                  case /* RectangleWithStaticHeight */0 :
                      return ;
                  case /* Circle */1 :
                  case /* Square */2 :
                      return shape._0;
                  
                }
              }), t.shape);
}

var innerSpace = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS");

var spacerVerticalSmaller = Particle_Spacer_Ds.makeVerticalAndHorizontal("XS", "S", undefined);

var particleSpacerVerticalSmaller = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, spacerVerticalSmaller);

var particleSpacerVerticalSmallerWithMedValue = Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeAll("M")), undefined, undefined, spacerVerticalSmaller);

function topTeaserButtons_textStyleDefault(asset) {
  return Atom_Text_Ds.makeTopTeaser(asset, {
              NAME: "Cta",
              VAL: "Default"
            });
}

function topTeaserButtons_textStyleDisabled(asset) {
  return Atom_Text_Ds.makeTopTeaser(asset, {
              NAME: "Cta",
              VAL: "Disabled"
            });
}

var topTeaserButtons_shape = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
      TAG: /* RectangleWithStaticHeight */0,
      _0: 40
    });

var topTeaserButtons_spacer = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XS", "S", undefined));

var topTeaserButtons_iconSize = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS");

var topTeaserButtons = {
  textStyleDefault: topTeaserButtons_textStyleDefault,
  textStyleDisabled: topTeaserButtons_textStyleDisabled,
  shape: topTeaserButtons_shape,
  spacer: topTeaserButtons_spacer,
  iconSize: topTeaserButtons_iconSize
};

function makeStyle(textStyleOpt, backgroundOpt, spacerOpt, borderOpt, shapeOpt, borderFocusOpt, hoverOpt, block, display, kindOpt, zIndexOpt, param) {
  var textStyle = textStyleOpt !== undefined ? textStyleOpt : Atom_Text_Ds.cta;
  var background = backgroundOpt !== undefined ? Caml_option.valFromOption(backgroundOpt) : Particle_Background_Ds.transparent;
  var spacer = spacerOpt !== undefined ? Caml_option.valFromOption(spacerOpt) : Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("None"));
  var border = borderOpt !== undefined ? Caml_option.valFromOption(borderOpt) : undefined;
  var shape = shapeOpt !== undefined ? Caml_option.valFromOption(shapeOpt) : Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* Rectangle */0);
  var borderFocus = borderFocusOpt !== undefined ? borderFocusOpt : /* Accessibility */0;
  var hover = hoverOpt !== undefined ? Caml_option.valFromOption(hoverOpt) : /* Opacity */5;
  var kind = kindOpt !== undefined ? kindOpt : /* Normal */0;
  var zIndex = zIndexOpt !== undefined ? Caml_option.valFromOption(zIndexOpt) : ({
        TAG: /* Exact */0,
        _0: /* Cta */4
      });
  return {
          textStyle: textStyle,
          background: background,
          spacer: spacer,
          border: border,
          shape: shape,
          borderFocus: borderFocus,
          block: block,
          hover: hover,
          display: display,
          kind: kind,
          zIndex: zIndex
        };
}

function makeTeaserHoverPlay(progression, icon) {
  var textStyle = Atom_Text_Ds.makeWhiteCta(Belt_Option.map(icon, (function (icon) {
              return {
                      TAG: /* Icon */1,
                      _0: {
                        position: {
                          TAG: /* Left */0,
                          _0: innerSpace
                        },
                        icon: icon,
                        size: topTeaserButtons_iconSize
                      }
                    };
            })));
  var border = progression !== undefined ? Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
              TAG: /* Progression */3,
              _0: progression
            })) : undefined;
  return makeStyle(textStyle, Caml_option.some(Particle_Background_Ds.white), Caml_option.some(topTeaserButtons_spacer), Caml_option.some(border), Caml_option.some(topTeaserButtons_shape), undefined, undefined, {
              justifyContent: "center",
              alignItems: "center",
              autoSize: undefined,
              wrap: /* OnOneLine */0,
              alignSelf: undefined,
              position: undefined,
              overflow: undefined
            }, undefined, undefined, undefined, undefined);
}

function makeStyleWatch(progression, icon, backgroundColor) {
  var textStyle = icon !== undefined ? Atom_Text_Ds.makeCtaWithAsset({
          TAG: /* Icon */1,
          _0: {
            position: {
              TAG: /* Left */0,
              _0: innerSpace
            },
            icon: icon,
            size: topTeaserButtons_iconSize
          }
        }) : Atom_Text_Ds.cta;
  var border = progression !== undefined ? Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
              TAG: /* Progression */3,
              _0: progression
            })) : undefined;
  return makeStyle(textStyle, Caml_option.some(backgroundColor), Caml_option.some(topTeaserButtons_spacer), Caml_option.some(border), Caml_option.some(topTeaserButtons_shape), undefined, undefined, {
              justifyContent: "center",
              alignItems: "center",
              autoSize: undefined,
              wrap: /* OnOneLine */0,
              alignSelf: undefined,
              position: undefined,
              overflow: undefined
            }, undefined, undefined, undefined, undefined);
}

function makeStyleLight(asset) {
  return makeStyle(Curry._1(topTeaserButtons_textStyleDefault, asset), undefined, Caml_option.some(topTeaserButtons_spacer), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                          TAG: /* Cta */2,
                          _0: /* Active */0,
                          _1: "Regular"
                        }))), Caml_option.some(topTeaserButtons_shape), undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

function make(style) {
  if (style.TAG === /* Close */0) {
    return makeStyle(Atom_Text_Ds.Message.close(style._0), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("XXS"))), undefined, undefined, undefined, {
                TAG: /* Border */0,
                _0: undefined
              }, undefined, undefined, undefined, undefined, undefined);
  } else if (style._0) {
    return makeStyle(Atom_Text_Ds.makeMessage("SubHeader"), undefined, undefined, undefined, undefined, undefined, /* SubHeaderUnderline */2, undefined, undefined, undefined, undefined, undefined);
  } else {
    return makeStyle(Atom_Text_Ds.makeMessage({
                    NAME: "Cta",
                    VAL: "Default"
                  }), undefined, undefined, undefined, undefined, undefined, /* Underline */1, undefined, undefined, undefined, undefined, undefined);
  }
}

var Message = {
  make: make
};

var hover = /* Opacity */5;

var border = Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* Header */17));

var colorHover = {
  TAG: /* Color */1,
  _0: "HoverGrey"
};

function createSquare(icon) {
  return makeStyle(Atom_Text_Ds.Header.make({
                  NAME: "Cta",
                  VAL: "Default"
                }, {
                  TAG: /* Icon */1,
                  _0: {
                    position: /* Alone */0,
                    icon: icon,
                    size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")
                  }
                }, undefined), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("None"))), Caml_option.some(border), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, {
                      TAG: /* Square */2,
                      _0: Type_Header.Constants.height.m
                    }, undefined, undefined, {
                      TAG: /* Square */2,
                      _0: Type_Header.Constants.height.default
                    })), undefined, Caml_option.some(hover), {
              justifyContent: "center",
              alignItems: "center",
              autoSize: undefined,
              wrap: /* OnOneLine */0,
              alignSelf: "center",
              position: undefined,
              overflow: undefined
            }, undefined, undefined, undefined, undefined);
}

var activeBase = makeStyle(Atom_Text_Ds.Header.make({
          NAME: "Cta",
          VAL: "Active"
        }, undefined, undefined), Caml_option.some(Particle_Background_Ds.white), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("XS"))), Caml_option.some(border), undefined, undefined, Caml_option.some(hover), {
      justifyContent: undefined,
      alignItems: "center",
      autoSize: undefined,
      wrap: /* OnOneLine */0,
      alignSelf: undefined,
      position: undefined,
      overflow: undefined
    }, undefined, undefined, undefined, undefined);

function inactiveBase(asset) {
  return {
          textStyle: Atom_Text_Ds.Header.make({
                NAME: "Cta",
                VAL: "Default"
              }, asset, undefined),
          background: Particle_Background_Ds.transparent,
          spacer: activeBase.spacer,
          border: activeBase.border,
          shape: activeBase.shape,
          borderFocus: activeBase.borderFocus,
          block: activeBase.block,
          hover: activeBase.hover,
          display: activeBase.display,
          kind: activeBase.kind,
          zIndex: activeBase.zIndex
        };
}

function getLogoStyle(orientation, logoBerne) {
  var logo = orientation ? ({
        NAME: "ArteVerticalLogo",
        VAL: "Header"
      }) : "ArteHorizontalLogo";
  if (logoBerne) {
    return {
            NAME: "WithWrapper",
            VAL: [
              logo,
              "Berne"
            ]
          };
  } else {
    return logo;
  }
}

function createUser(display) {
  return makeStyle(Atom_Text_Ds.Header.make({
                  NAME: "Cta",
                  VAL: "Default"
                }, {
                  TAG: /* Icon */1,
                  _0: {
                    position: {
                      TAG: /* Left */0,
                      _0: Particle_Screen_Ds.make(undefined, undefined, undefined, "XS", undefined, "Zero")
                    },
                    icon: "User",
                    size: Particle_Screen_Ds.make(undefined, undefined, undefined, "S", undefined, "XS")
                  }
                }, {
                  TAG: /* Main */0,
                  _0: "HoverGrey"
                }), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeVerticalAndHorizontal("XS", "XXS", undefined)), undefined, Particle_Spacer_Ds.makeAll("None"))), Caml_option.some(border), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, {
                      TAG: /* Square */2,
                      _0: Type_Header.Constants.height.m
                    }, /* Rectangle */0, undefined, {
                      TAG: /* Square */2,
                      _0: Type_Header.Constants.height.default
                    })), undefined, Caml_option.some(colorHover), {
              justifyContent: "center",
              alignItems: "center",
              autoSize: undefined,
              wrap: /* OnOneLine */0,
              alignSelf: "center",
              position: undefined,
              overflow: undefined
            }, Caml_option.some(display), undefined, undefined, undefined);
}

function make$1(style) {
  if (typeof style === "number") {
    switch (style) {
      case /* BaseNavigation */0 :
          return inactiveBase(undefined);
      case /* Close */1 :
          var init = createSquare("MenuClose");
          return {
                  textStyle: init.textStyle,
                  background: init.background,
                  spacer: init.spacer,
                  border: init.border,
                  shape: init.shape,
                  borderFocus: init.borderFocus,
                  block: init.block,
                  hover: undefined,
                  display: init.display,
                  kind: init.kind,
                  zIndex: init.zIndex
                };
      case /* OneTimeEvent */2 :
          var init$1 = inactiveBase(undefined);
          return {
                  textStyle: init$1.textStyle,
                  background: init$1.background,
                  spacer: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("XXS")),
                  border: init$1.border,
                  shape: init$1.shape,
                  borderFocus: init$1.borderFocus,
                  block: {
                    justifyContent: "center",
                    alignItems: "center",
                    autoSize: undefined,
                    wrap: /* OnOneLine */0,
                    alignSelf: undefined,
                    position: undefined,
                    overflow: undefined
                  },
                  hover: init$1.hover,
                  display: init$1.display,
                  kind: init$1.kind,
                  zIndex: init$1.zIndex
                };
      case /* RedirectionAnchor */3 :
          var init$2 = inactiveBase(undefined);
          return {
                  textStyle: Atom_Text_Ds.Header.redirectionAnchor,
                  background: init$2.background,
                  spacer: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("XXS")),
                  border: init$2.border,
                  shape: init$2.shape,
                  borderFocus: init$2.borderFocus,
                  block: {
                    justifyContent: "center",
                    alignItems: "center",
                    autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceAvailable),
                    wrap: undefined,
                    alignSelf: undefined,
                    position: undefined,
                    overflow: "hidden"
                  },
                  hover: init$2.hover,
                  display: init$2.display,
                  kind: init$2.kind,
                  zIndex: init$2.zIndex
                };
      case /* Search */4 :
          return createSquare({
                      NAME: "Search",
                      VAL: "White"
                    });
      case /* GenreItem */5 :
          return makeStyle(Atom_Text_Ds.Header.makeSelectGenre, undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
      
    }
  } else {
    switch (style.TAG | 0) {
      case /* BurgerMenu */0 :
          if (style._0) {
            if (style._1) {
              return createSquare("BurgerMenu");
            } else {
              return createSquare("MenuConcert");
            }
          }
          var init$3 = createSquare("MenuClose");
          return {
                  textStyle: init$3.textStyle,
                  background: Particle_Background_Ds.dropdownMenu,
                  spacer: init$3.spacer,
                  border: init$3.border,
                  shape: init$3.shape,
                  borderFocus: init$3.borderFocus,
                  block: init$3.block,
                  hover: init$3.hover,
                  display: init$3.display,
                  kind: init$3.kind,
                  zIndex: init$3.zIndex
                };
      case /* Concert */1 :
          var display = style._0 ? Particle_Screen_Ds.make(undefined, undefined, "inlineFlex", undefined, undefined, "none") : Particle_Screen_Ds.make(undefined, undefined, undefined, "inlineFlex", undefined, "none");
          return makeStyle(Atom_Text_Ds.Header.concert, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("XS"))), Caml_option.some(border), undefined, undefined, Caml_option.some(hover), {
                      justifyContent: "center",
                      alignItems: "center",
                      autoSize: undefined,
                      wrap: /* OnOneLine */0,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, Caml_option.some(display), undefined, undefined, undefined);
      case /* ConcertLogo */2 :
          return makeStyle(Atom_Text_Ds.Header.concertLogo(style._1), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeRight("XXS"))), Caml_option.some(border), undefined, undefined, Caml_option.some(hover), undefined, Caml_option.some(style._0), undefined, undefined, undefined);
      case /* Gear */3 :
          var background = style._0 ? Particle_Background_Ds.transparent : Particle_Background_Ds.dropdownMenu;
          var init$4 = createSquare("Gear");
          return {
                  textStyle: init$4.textStyle,
                  background: background,
                  spacer: init$4.spacer,
                  border: init$4.border,
                  shape: init$4.shape,
                  borderFocus: init$4.borderFocus,
                  block: init$4.block,
                  hover: init$4.hover,
                  display: init$4.display,
                  kind: init$4.kind,
                  zIndex: init$4.zIndex
                };
      case /* InstallMobileApp */4 :
          return makeStyle(Atom_Text_Ds.Header.installMobileApp, Caml_option.some(Particle_Background_Ds.orange), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XXS", "XXS", undefined))), Caml_option.some(border), undefined, undefined, Caml_option.some(hover), {
                      justifyContent: undefined,
                      alignItems: "center",
                      autoSize: undefined,
                      wrap: /* OnOneLine */0,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, Caml_option.some(style._0), undefined, undefined, undefined);
      case /* LanguageSwitcher */5 :
          var background$1 = style._1 ? Particle_Background_Ds.transparent : Particle_Background_Ds.dropdownMenu;
          var init$5 = inactiveBase({
                TAG: /* Icon */1,
                _0: {
                  position: {
                    TAG: /* Right */1,
                    _0: innerSpace
                  },
                  icon: {
                    NAME: "Angle",
                    VAL: [
                      "Down",
                      "White"
                    ]
                  },
                  size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")
                }
              });
          return {
                  textStyle: init$5.textStyle,
                  background: background$1,
                  spacer: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("XXS")),
                  border: init$5.border,
                  shape: Particle_Screen_Ds.make(undefined, undefined, {
                        TAG: /* RectangleWithStaticHeight */0,
                        _0: Type_Header.Constants.height.m
                      }, undefined, undefined, {
                        TAG: /* RectangleWithStaticHeight */0,
                        _0: Type_Header.Constants.height.default
                      }),
                  borderFocus: init$5.borderFocus,
                  block: {
                    justifyContent: "center",
                    alignItems: "center",
                    autoSize: undefined,
                    wrap: /* OnOneLine */0,
                    alignSelf: undefined,
                    position: undefined,
                    overflow: undefined
                  },
                  hover: colorHover,
                  display: Caml_option.some(style._0),
                  kind: init$5.kind,
                  zIndex: init$5.zIndex
                };
      case /* LanguageSwitcherItem */6 :
          if (style._0) {
            return {
                    textStyle: Atom_Text_Ds.Header.makeLanguageSwitcher({
                          NAME: "Cta",
                          VAL: "Active"
                        }),
                    background: activeBase.background,
                    spacer: Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeAll("None")), undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XXS", "S", undefined)),
                    border: activeBase.border,
                    shape: activeBase.shape,
                    borderFocus: activeBase.borderFocus,
                    block: {
                      justifyContent: "center",
                      alignItems: "center",
                      autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceAvailable),
                      wrap: /* OnOneLine */0,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    },
                    hover: undefined,
                    display: activeBase.display,
                    kind: activeBase.kind,
                    zIndex: activeBase.zIndex
                  };
          }
          var init$6 = inactiveBase(undefined);
          return {
                  textStyle: Atom_Text_Ds.Header.makeLanguageSwitcher({
                        NAME: "Cta",
                        VAL: "Default"
                      }),
                  background: init$6.background,
                  spacer: Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeAll("None")), undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XXS", "M", undefined)),
                  border: init$6.border,
                  shape: init$6.shape,
                  borderFocus: init$6.borderFocus,
                  block: {
                    justifyContent: "center",
                    alignItems: "center",
                    autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceAvailable),
                    wrap: /* OnOneLine */0,
                    alignSelf: undefined,
                    position: undefined,
                    overflow: undefined
                  },
                  hover: colorHover,
                  display: init$6.display,
                  kind: init$6.kind,
                  zIndex: init$6.zIndex
                };
      case /* Logo */7 :
          var display$1 = style._2;
          var logoBerne = style._1;
          var orientation = style._0;
          if (orientation) {
            var init$7 = inactiveBase({
                  TAG: /* Logo */0,
                  _0: {
                    position: /* Alone */0,
                    logo: getLogoStyle(orientation, logoBerne)
                  }
                });
            return {
                    textStyle: init$7.textStyle,
                    background: init$7.background,
                    spacer: Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.make("Zero", "Zero", "Zero", "XXS", undefined)), undefined, undefined, Particle_Spacer_Ds.makeHorizontal("XXS")),
                    border: init$7.border,
                    shape: init$7.shape,
                    borderFocus: init$7.borderFocus,
                    block: {
                      justifyContent: undefined,
                      alignItems: "center",
                      autoSize: undefined,
                      wrap: /* OnOneLine */0,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    },
                    hover: {
                      TAG: /* Color */1,
                      _0: "White"
                    },
                    display: Caml_option.some(display$1),
                    kind: init$7.kind,
                    zIndex: init$7.zIndex
                  };
          }
          var init$8 = inactiveBase({
                TAG: /* Logo */0,
                _0: {
                  position: {
                    TAG: /* Left */0,
                    _0: innerSpace
                  },
                  logo: getLogoStyle(orientation, logoBerne)
                }
              });
          return {
                  textStyle: init$8.textStyle,
                  background: init$8.background,
                  spacer: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeHorizontal("XS")),
                  border: init$8.border,
                  shape: init$8.shape,
                  borderFocus: init$8.borderFocus,
                  block: {
                    justifyContent: undefined,
                    alignItems: "center",
                    autoSize: undefined,
                    wrap: /* OnOneLine */0,
                    alignSelf: undefined,
                    position: undefined,
                    overflow: undefined
                  },
                  hover: {
                    TAG: /* Color */1,
                    _0: "White"
                  },
                  display: Caml_option.some(display$1),
                  kind: init$8.kind,
                  zIndex: init$8.zIndex
                };
      case /* MenuNavigation */8 :
          switch (style._0) {
            case /* Active */0 :
                return {
                        textStyle: Atom_Text_Ds.Header.makeMenuNavigation(undefined, {
                              NAME: "Cta",
                              VAL: "Active"
                            }),
                        background: activeBase.background,
                        spacer: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XXS", "XS", undefined)),
                        border: activeBase.border,
                        shape: activeBase.shape,
                        borderFocus: activeBase.borderFocus,
                        block: activeBase.block,
                        hover: activeBase.hover,
                        display: activeBase.display,
                        kind: activeBase.kind,
                        zIndex: activeBase.zIndex
                      };
            case /* Inactive */1 :
                var init$9 = inactiveBase(undefined);
                return {
                        textStyle: Atom_Text_Ds.Header.makeMenuNavigation(undefined, {
                              NAME: "Cta",
                              VAL: "Default"
                            }),
                        background: init$9.background,
                        spacer: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XXS", "XS", undefined)),
                        border: init$9.border,
                        shape: init$9.shape,
                        borderFocus: init$9.borderFocus,
                        block: init$9.block,
                        hover: init$9.hover,
                        display: init$9.display,
                        kind: init$9.kind,
                        zIndex: init$9.zIndex
                      };
            case /* External */2 :
                var init$10 = inactiveBase(undefined);
                return {
                        textStyle: Atom_Text_Ds.Header.makeMenuNavigation({
                              TAG: /* Icon */1,
                              _0: {
                                position: {
                                  TAG: /* Right */1,
                                  _0: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XL")
                                },
                                icon: "Arrow",
                                size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")
                              }
                            }, {
                              NAME: "Cta",
                              VAL: "Default"
                            }),
                        background: init$10.background,
                        spacer: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XXS", "XS", undefined)),
                        border: init$10.border,
                        shape: init$10.shape,
                        borderFocus: init$10.borderFocus,
                        block: {
                          justifyContent: "spaceBetween",
                          alignItems: "center",
                          autoSize: undefined,
                          wrap: /* OnOneLine */0,
                          alignSelf: undefined,
                          position: undefined,
                          overflow: undefined
                        },
                        hover: init$10.hover,
                        display: init$10.display,
                        kind: init$10.kind,
                        zIndex: init$10.zIndex
                      };
            
          }
      case /* SettingsMenu */9 :
          var init$11 = createSquare("Gear");
          return {
                  textStyle: init$11.textStyle,
                  background: init$11.background,
                  spacer: init$11.spacer,
                  border: init$11.border,
                  shape: init$11.shape,
                  borderFocus: init$11.borderFocus,
                  block: init$11.block,
                  hover: init$11.hover,
                  display: Caml_option.some(style._0),
                  kind: init$11.kind,
                  zIndex: init$11.zIndex
                };
      case /* SettingsMenuLink */10 :
          var init$12 = inactiveBase(undefined);
          return {
                  textStyle: Atom_Text_Ds.Header.makeMenuNavigation(undefined, {
                        NAME: "Cta",
                        VAL: "Default"
                      }),
                  background: init$12.background,
                  spacer: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XXS", "XS", undefined)),
                  border: init$12.border,
                  shape: init$12.shape,
                  borderFocus: init$12.borderFocus,
                  block: init$12.block,
                  hover: init$12.hover,
                  display: Caml_option.some(style._0),
                  kind: init$12.kind,
                  zIndex: init$12.zIndex
                };
      case /* User */11 :
          return createUser(style._0);
      case /* UserPanel */12 :
          var background$2 = style._1 ? Particle_Background_Ds.transparent : Particle_Background_Ds.dropdownMenu;
          var init$13 = createUser(style._0);
          return {
                  textStyle: init$13.textStyle,
                  background: background$2,
                  spacer: init$13.spacer,
                  border: init$13.border,
                  shape: init$13.shape,
                  borderFocus: init$13.borderFocus,
                  block: init$13.block,
                  hover: init$13.hover,
                  display: init$13.display,
                  kind: init$13.kind,
                  zIndex: init$13.zIndex
                };
      case /* HeaderPanel */13 :
          var icon;
          switch (style._0) {
            case /* Setting */0 :
                icon = "Gear";
                break;
            case /* Login */1 :
                icon = "User";
                break;
            case /* Logout */2 :
                icon = "MenuClose";
                break;
            
          }
          return makeStyle(Atom_Text_Ds.Header.makeUserPanel({
                          TAG: /* Icon */1,
                          _0: {
                            position: {
                              TAG: /* Left */0,
                              _0: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")
                            },
                            icon: icon,
                            size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")
                          }
                        }), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XXS", "M", undefined))), Caml_option.some(border), undefined, undefined, Caml_option.some(colorHover), undefined, undefined, undefined, undefined, undefined);
      case /* Social */14 :
          return makeStyle(Atom_Text_Ds.Header.make({
                          NAME: "Cta",
                          VAL: "Default"
                        }, {
                          TAG: /* Icon */1,
                          _0: {
                            position: /* Alone */0,
                            icon: style._0,
                            size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")
                          }
                        }, undefined), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("None"))), Caml_option.some(border), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, {
                              TAG: /* RectangleWithStaticHeight */0,
                              _0: Type_Header.Constants.height.m
                            }, undefined, {
                              TAG: /* RectangleWithStaticHeight */0,
                              _0: 22
                            })), undefined, Caml_option.some(hover), {
                      justifyContent: "center",
                      alignItems: "center",
                      autoSize: undefined,
                      wrap: undefined,
                      alignSelf: "center",
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* ConcertGenre */15 :
          return makeStyle(Atom_Text_Ds.Header.make({
                          NAME: "Cta",
                          VAL: "Default"
                        }, {
                          TAG: /* Icon */1,
                          _0: {
                            position: {
                              TAG: /* Right */1,
                              _0: innerSpace
                            },
                            icon: {
                              NAME: "Angle",
                              VAL: [
                                "Down",
                                "White"
                              ]
                            },
                            size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XS")
                          }
                        }, undefined), Caml_option.some(style._0 ? Particle_Background_Ds.transparent : Particle_Background_Ds.selectConcertGenre), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("XXS"))), Caml_option.some(border), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                              TAG: /* RectangleWithStaticHeight */0,
                              _0: Type_Header.Constants.height.m
                            })), undefined, Caml_option.some(hover), {
                      justifyContent: "center",
                      alignItems: "center",
                      autoSize: undefined,
                      wrap: undefined,
                      alignSelf: "center",
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* ConcertMenuNavigation */16 :
          return makeStyle(Atom_Text_Ds.Header.makeConcertMenuNavigation(style._0), undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
      
    }
  }
}

var Header = {
  hover: hover,
  border: border,
  colorHover: colorHover,
  createSquare: createSquare,
  activeBase: activeBase,
  inactiveBase: inactiveBase,
  getLogoStyle: getLogoStyle,
  createUser: createUser,
  make: make$1
};

function make$2(socialMedia) {
  var tmp;
  switch (socialMedia) {
    case /* Facebook */0 :
        tmp = "Facebook";
        break;
    case /* Twitter */1 :
        tmp = "Twitter";
        break;
    case /* Whatsapp */2 :
        tmp = "Whatsapp";
        break;
    
  }
  return makeStyle(Atom_Text_Ds.Sharebar.makeSocial(socialMedia), undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, {
                      TAG: /* Circle */1,
                      _0: 80
                    }, undefined, {
                      TAG: /* Circle */1,
                      _0: 40
                    })), undefined, Caml_option.some({
                  TAG: /* Background */2,
                  _0: tmp
                }), {
              justifyContent: "center",
              alignItems: undefined,
              autoSize: undefined,
              wrap: undefined,
              alignSelf: undefined,
              position: undefined,
              overflow: undefined
            }, undefined, undefined, undefined, undefined);
}

var Sharebar = {
  make: make$2
};

function make$3(style) {
  if (typeof style === "number") {
    switch (style) {
      case /* Newsletter */0 :
          return makeStyle(Atom_Text_Ds.Footer.newsletter, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S"))), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                  TAG: /* Textfield */7,
                                  _0: /* Inactive */1
                                }))), undefined, undefined, {
                      TAG: /* Border */0,
                      _0: {
                        TAG: /* Textfield */7,
                        _0: /* Active */0
                      }
                    }, undefined, undefined, undefined, undefined, undefined);
      case /* Tos */1 :
          return makeStyle(Atom_Text_Ds.makeTos({
                          NAME: "Cta",
                          VAL: "Default"
                        }), undefined, undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, {
                              TAG: /* Circle */1,
                              _0: 16
                            }, undefined, undefined, {
                              TAG: /* Circle */1,
                              _0: 12
                            })), undefined, /* Opacity */5, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.inline)), undefined, undefined, undefined);
      case /* Link */2 :
          return makeStyle(Atom_Text_Ds.Footer.make({
                          NAME: "Cta",
                          VAL: "Default"
                        }), undefined, undefined, undefined, undefined, undefined, /* Opacity */5, undefined, undefined, undefined, undefined, undefined);
      case /* TitleLink */3 :
          return makeStyle(Atom_Text_Ds.Footer.title, undefined, undefined, undefined, undefined, undefined, /* Underline */1, undefined, undefined, undefined, undefined, undefined);
      
    }
  } else {
    switch (style.TAG | 0) {
      case /* Partner */0 :
          return makeStyle(Atom_Text_Ds.Footer.makePartner(style._0), undefined, undefined, undefined, undefined, undefined, /* Opacity */5, undefined, undefined, undefined, undefined, undefined);
      case /* Social */1 :
          return makeStyle(Atom_Text_Ds.Footer.makeSocial(style._0), undefined, undefined, undefined, undefined, undefined, /* Opacity */5, undefined, undefined, undefined, undefined, undefined);
      case /* Title */2 :
          return makeStyle(Atom_Text_Ds.Footer.makeTitle(style._0), undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
      
    }
  }
}

var Footer = {
  make: make$3
};

var shapeArrow = Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
      TAG: /* Circle */1,
      _0: 40
    });

var shapeControl = Particle_Screen_Ds.make(undefined, undefined, {
      TAG: /* Circle */1,
      _0: 16
    }, undefined, undefined, {
      TAG: /* Circle */1,
      _0: 12
    });

function make$4(style) {
  if (typeof style === "number") {
    switch (style) {
      case /* ControlPause */0 :
          return makeStyle(Atom_Text_Ds.Carousel.pause, Caml_option.some(Particle_Background_Ds.transparent), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("None"))), undefined, Caml_option.some(shapeControl), undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      case /* ControlPlay */1 :
          return makeStyle(Atom_Text_Ds.Carousel.play, Caml_option.some(Particle_Background_Ds.transparent), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("None"))), undefined, Caml_option.some(shapeControl), undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      case /* NextArrow */2 :
          return makeStyle(Atom_Text_Ds.Carousel.makeArrow("Right"), Caml_option.some(Particle_Background_Ds.white), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("None"))), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* SliderButton */27))), Caml_option.some(shapeArrow), undefined, /* Scale */3, {
                      justifyContent: "center",
                      alignItems: undefined,
                      autoSize: undefined,
                      wrap: undefined,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* PreviousArrow */3 :
          return makeStyle(Atom_Text_Ds.Carousel.makeArrow("Left"), Caml_option.some(Particle_Background_Ds.white), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("None"))), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* SliderButton */27))), Caml_option.some(shapeArrow), undefined, /* Scale */3, {
                      justifyContent: "center",
                      alignItems: undefined,
                      autoSize: undefined,
                      wrap: undefined,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      
    }
  } else {
    var category = style._0;
    if (category) {
      return makeStyle(Atom_Text_Ds.Carousel.bullet, Caml_option.some(Particle_Background_Ds.activeBullet(category._0)), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("None"))), undefined, Caml_option.some(shapeControl), undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    } else {
      return makeStyle(Atom_Text_Ds.Carousel.bullet, Caml_option.some(Particle_Background_Ds.white), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("None"))), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, {
                          TAG: /* Circle */1,
                          _0: 10
                        }, undefined, undefined, {
                          TAG: /* Circle */1,
                          _0: 8
                        })), undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    }
  }
}

var Carousel = {
  make: make$4
};

function make$5(style) {
  if (typeof style === "number") {
    switch (style) {
      case /* NavPrev */0 :
          return makeStyle(Atom_Text_Ds.Slider.makeNav("Left"), Caml_option.some(Particle_Background_Ds.white), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("None"))), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* SliderButton */27))), Caml_option.some(shapeArrow), undefined, /* Scale */3, {
                      justifyContent: "center",
                      alignItems: undefined,
                      autoSize: undefined,
                      wrap: undefined,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* NavNext */1 :
          return makeStyle(Atom_Text_Ds.Slider.makeNav("Right"), Caml_option.some(Particle_Background_Ds.white), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("None"))), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* SliderButton */27))), Caml_option.some(shapeArrow), undefined, /* Scale */3, {
                      justifyContent: "center",
                      alignItems: undefined,
                      autoSize: undefined,
                      wrap: undefined,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* DownloadAll */2 :
          return makeStyle(Atom_Text_Ds.Slider.downloadAll, Caml_option.some(Particle_Background_Ds.primary), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("S", "S", undefined))), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                  TAG: /* Cta */2,
                                  _0: /* Active */0,
                                  _1: "Regular"
                                }))), undefined, undefined, /* Opacity */5, {
                      justifyContent: undefined,
                      alignItems: "center",
                      autoSize: undefined,
                      wrap: undefined,
                      alignSelf: "end_",
                      position: undefined,
                      overflow: undefined
                    }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, Css.inlineFlex, undefined, undefined, CssJs.none)), undefined, undefined, undefined);
      
    }
  } else {
    if (style.TAG !== /* SeeMore */0) {
      return makeStyle(style._0, undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
    }
    var theme = style._0;
    return makeStyle(typeof theme === "object" && theme.NAME === "PlayNext" ? Atom_Text_Ds.Slider.seeMorePlayNext : Atom_Text_Ds.Slider.seeMore, Caml_option.some(typeof theme === "object" && theme.NAME === "PlayNext" ? Particle_Background_Ds.white : Particle_Background_Ds.primary), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("S", "S", undefined))), Caml_option.some(theme === "Info" || theme === "White" ? Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* SliderButton */27)) : undefined), undefined, undefined, undefined, {
                justifyContent: undefined,
                alignItems: "center",
                autoSize: undefined,
                wrap: undefined,
                alignSelf: "end_",
                position: undefined,
                overflow: undefined
              }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, Css.inlineFlex, undefined, undefined, CssJs.none)), undefined, undefined, undefined);
  }
}

var Slider = {
  make: make$5
};

function make$6(style) {
  switch (style) {
    case /* Genre */0 :
        return makeStyle(Atom_Text_Ds.Teaser.toParent(Atom_Text_Ds.Teaser.makeGuide({
                            NAME: "Cta",
                            VAL: "Default"
                          })), undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
    case /* TeaserContainerStandard */1 :
        return makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), {
                    justifyContent: undefined,
                    alignItems: "center",
                    autoSize: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* AllPlaceAvailable */0)),
                    wrap: undefined,
                    alignSelf: undefined,
                    position: undefined,
                    overflow: undefined
                  }, undefined, undefined, Caml_option.some(undefined), undefined);
    case /* TeaserContainerBig */2 :
        return makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), {
                    justifyContent: undefined,
                    alignItems: "flexStart",
                    autoSize: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* AllPlaceAvailable */0)),
                    wrap: undefined,
                    alignSelf: undefined,
                    position: undefined,
                    overflow: undefined
                  }, undefined, undefined, Caml_option.some(undefined), undefined);
    
  }
}

var TeaserGuide = {
  make: make$6
};

function makeStyleFavorite(spacer, textStyle, shape, param) {
  return makeStyle(textStyle, undefined, Caml_option.some(spacer), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                          TAG: /* Cta */2,
                          _0: /* Active */0,
                          _1: "Regular"
                        }))), shape, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
}

function make$7(style, variation) {
  if (style) {
    switch (variation) {
      case /* Small */0 :
          return makeStyle(Atom_Text_Ds.Favorite.makeSmall("Filled"), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      case /* Program */1 :
          return makeStyleFavorite(particleSpacerVerticalSmaller, Atom_Text_Ds.Favorite.makeProgramPage("Filled"), undefined, undefined);
      case /* TopTeaser */2 :
          return makeStyleFavorite(topTeaserButtons_spacer, Atom_Text_Ds.Favorite.makeTeaser("Filled"), Caml_option.some(topTeaserButtons_shape), undefined);
      case /* ContentCollection */3 :
          return makeStyleFavorite(particleSpacerVerticalSmaller, Atom_Text_Ds.Favorite.makeContentCollection("Filled"), undefined, undefined);
      case /* TeaserHover */4 :
          return makeStyle(Atom_Text_Ds.Favorite.makeTeaserHover("Filled"), undefined, Caml_option.some(topTeaserButtons_spacer), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* TeaserCta */28))), Caml_option.some(topTeaserButtons_shape), undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      
    }
  } else {
    switch (variation) {
      case /* Small */0 :
          return makeStyle(Atom_Text_Ds.Favorite.makeSmall("Default"), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      case /* Program */1 :
          return makeStyleFavorite(particleSpacerVerticalSmaller, Atom_Text_Ds.Favorite.makeProgramPage("Default"), undefined, undefined);
      case /* TopTeaser */2 :
          return makeStyleFavorite(topTeaserButtons_spacer, Atom_Text_Ds.Favorite.makeTeaser("Default"), Caml_option.some(topTeaserButtons_shape), undefined);
      case /* ContentCollection */3 :
          return makeStyleFavorite(particleSpacerVerticalSmaller, Atom_Text_Ds.Favorite.makeContentCollection("Default"), undefined, undefined);
      case /* TeaserHover */4 :
          return makeStyle(Atom_Text_Ds.Favorite.makeTeaserHover("Default"), undefined, Caml_option.some(topTeaserButtons_spacer), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* TeaserCta */28))), Caml_option.some(topTeaserButtons_shape), undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      
    }
  }
}

var Favorite = {
  makeStyleFavorite: makeStyleFavorite,
  make: make$7
};

function make$8(style) {
  if (style) {
    return makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
  } else {
    return makeStyle(Atom_Text_Ds.EventZone.button, Caml_option.some(Particle_Background_Ds.white), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("S", "S", undefined))), undefined, undefined, undefined, undefined, {
                justifyContent: "center",
                alignItems: "center",
                autoSize: undefined,
                wrap: /* OnOneLine */0,
                alignSelf: undefined,
                position: undefined,
                overflow: undefined
              }, undefined, undefined, undefined, undefined);
  }
}

var EventZone = {
  make: make$8
};

function make$9(style) {
  var commonStyle = function (background, textStyle) {
    return makeStyle(textStyle, background, Caml_option.some(particleSpacerVerticalSmallerWithMedValue), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                            TAG: /* Cta */2,
                            _0: /* Inactive */1,
                            _1: "Regular"
                          }))), undefined, undefined, {
                TAG: /* Border */0,
                _0: {
                  TAG: /* Cta */2,
                  _0: /* Active */0,
                  _1: "Regular"
                }
              }, undefined, undefined, undefined, undefined, undefined);
  };
  if (style) {
    return commonStyle(undefined, Atom_Text_Ds.SelectGenre.make(/* NotSelected */1));
  } else {
    return commonStyle(Caml_option.some(Particle_Background_Ds.selectGenreButtonSelected), Atom_Text_Ds.SelectGenre.make(/* Selected */0));
  }
}

var GenreSelect = {
  make: make$9
};

var menuItemBaseStyle = makeStyle(Atom_Text_Ds.Corporate.menuItem, Caml_option.some(Particle_Background_Ds.Corporate.menu), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeHorizontal("S"))), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, {
              TAG: /* RectangleWithStaticHeight */0,
              _0: Type_Header.Constants.height.m
            }, undefined, undefined, {
              TAG: /* RectangleWithStaticHeight */0,
              _0: Type_Header.Constants.height.default
            })), /* CorporateAccessibility */3, {
      TAG: /* Dash */4,
      _0: "Background",
      _1: "S"
    }, {
      justifyContent: "flexStart",
      alignItems: undefined,
      autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceAvailable),
      wrap: /* OnOneLine */0,
      alignSelf: undefined,
      position: undefined,
      overflow: undefined
    }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.inlineFlex)), undefined, undefined, undefined);

function makeBackgroundByHighlight(highlight) {
  if (highlight) {
    return Particle_Background_Ds.background;
  } else {
    return Particle_Background_Ds.Corporate.menu;
  }
}

function make$10(style) {
  switch (style.TAG | 0) {
    case /* ToggleButton */0 :
        var status = style._0;
        return makeStyle(Atom_Text_Ds.Corporate.makeToggleButton(status), Caml_option.some(Particle_Background_Ds.toggleCorporateButton), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S"))), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, status === "active" ? ({
                                    TAG: /* Corporate */1,
                                    _0: /* Active */0
                                  }) : ({
                                    TAG: /* Corporate */1,
                                    _0: /* Inactive */1
                                  })))), undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
    case /* MenuItem */1 :
        if (style._0) {
          return menuItemBaseStyle;
        } else {
          return {
                  textStyle: Atom_Text_Ds.Corporate.menuItemCurrent,
                  background: Particle_Background_Ds.background,
                  spacer: menuItemBaseStyle.spacer,
                  border: menuItemBaseStyle.border,
                  shape: menuItemBaseStyle.shape,
                  borderFocus: menuItemBaseStyle.borderFocus,
                  block: menuItemBaseStyle.block,
                  hover: {
                    TAG: /* Dash */4,
                    _0: "White",
                    _1: "S"
                  },
                  display: menuItemBaseStyle.display,
                  kind: menuItemBaseStyle.kind,
                  zIndex: menuItemBaseStyle.zIndex
                };
        }
    case /* MenuItemWithChilds */2 :
        var highlight = style._1;
        return {
                textStyle: Atom_Text_Ds.Corporate.makeMenuItemWithChilds(highlight, style._0),
                background: makeBackgroundByHighlight(highlight),
                spacer: menuItemBaseStyle.spacer,
                border: menuItemBaseStyle.border,
                shape: menuItemBaseStyle.shape,
                borderFocus: menuItemBaseStyle.borderFocus,
                block: menuItemBaseStyle.block,
                hover: menuItemBaseStyle.hover,
                display: menuItemBaseStyle.display,
                kind: menuItemBaseStyle.kind,
                zIndex: menuItemBaseStyle.zIndex
              };
    case /* MenuItemChild */3 :
        var highlight$1 = style._0;
        return {
                textStyle: Atom_Text_Ds.Corporate.makeMenuItemChild(highlight$1),
                background: makeBackgroundByHighlight(highlight$1),
                spacer: particleSpacerVerticalSmaller,
                border: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, /* CorporateMenuItemChild */7, undefined, undefined, /* None */19)),
                shape: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* Rectangle */0),
                borderFocus: menuItemBaseStyle.borderFocus,
                block: {
                  justifyContent: "flexStart",
                  alignItems: undefined,
                  autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceAvailable),
                  wrap: /* OnOneLine */0,
                  alignSelf: undefined,
                  position: undefined,
                  overflow: undefined
                },
                hover: undefined,
                display: menuItemBaseStyle.display,
                kind: menuItemBaseStyle.kind,
                zIndex: menuItemBaseStyle.zIndex
              };
    case /* SearchButton */4 :
        return {
                textStyle: Atom_Text_Ds.Corporate.makeSearchButton(style._0),
                background: Particle_Background_Ds.transparent,
                spacer: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XS", "XS", undefined)),
                border: menuItemBaseStyle.border,
                shape: menuItemBaseStyle.shape,
                borderFocus: menuItemBaseStyle.borderFocus,
                block: undefined,
                hover: /* Scale */3,
                display: menuItemBaseStyle.display,
                kind: menuItemBaseStyle.kind,
                zIndex: menuItemBaseStyle.zIndex
              };
    
  }
}

var Corporate = {
  menuItemBaseStyle: menuItemBaseStyle,
  makeBackgroundByHighlight: makeBackgroundByHighlight,
  make: make$10
};

var menuItemBaseStyle$1 = makeStyle(Atom_Text_Ds.Presse.menuItem, Caml_option.some(Particle_Background_Ds.Presse.menu), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeHorizontal("M"))), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, {
              TAG: /* RectangleWithStaticHeight */0,
              _0: Type_Header.Constants.height.m
            }, undefined, undefined, {
              TAG: /* RectangleWithStaticHeight */0,
              _0: Type_Header.Constants.height.default
            })), /* Accessibility */0, {
      TAG: /* Dash */4,
      _0: "White",
      _1: "M"
    }, {
      justifyContent: "flexStart",
      alignItems: undefined,
      autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceAvailable),
      wrap: /* OnOneLine */0,
      alignSelf: undefined,
      position: undefined,
      overflow: undefined
    }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.inlineFlex)), undefined, undefined, undefined);

function makeBackgroundByHighlight$1(highlight) {
  if (highlight) {
    return Particle_Background_Ds.orange;
  } else {
    return Particle_Background_Ds.Presse.menu;
  }
}

function makeNav(direction) {
  return makeStyle(Atom_Text_Ds.Presse.makeNav(direction), Caml_option.some(Particle_Background_Ds.white), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("None"))), Caml_option.some(undefined), Caml_option.some(shapeArrow), undefined, /* Scale */3, {
              justifyContent: "center",
              alignItems: undefined,
              autoSize: undefined,
              wrap: undefined,
              alignSelf: undefined,
              position: undefined,
              overflow: undefined
            }, undefined, undefined, undefined, undefined);
}

function make$11(style) {
  if (typeof style === "number") {
    switch (style) {
      case /* Base */0 :
          return makeStyle(Atom_Text_Ds.Presse.makeDefault, Caml_option.some(Particle_Background_Ds.Presse.button), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S"))), undefined, undefined, undefined, {
                      TAG: /* Border */0,
                      _0: undefined
                    }, undefined, undefined, undefined, undefined, undefined);
      case /* Disabled */1 :
          return makeStyle(Atom_Text_Ds.Presse.makeDefault, Caml_option.some(Particle_Background_Ds.Presse.disabledButton), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S"))), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                  TAG: /* Cta */2,
                                  _0: /* Inactive */1,
                                  _1: "Medium"
                                }))), undefined, undefined, /* NotAllowed */4, undefined, undefined, undefined, undefined, undefined);
      case /* MenuBrandTitle */2 :
          return makeStyle(Atom_Text_Ds.Presse.menuBrandTitle, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeRight("XL")), undefined, undefined, Particle_Spacer_Ds.makeRight("XS"))), undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
      case /* MenuItemHightlight */3 :
          return {
                  textStyle: menuItemBaseStyle$1.textStyle,
                  background: Particle_Background_Ds.orange,
                  spacer: menuItemBaseStyle$1.spacer,
                  border: menuItemBaseStyle$1.border,
                  shape: menuItemBaseStyle$1.shape,
                  borderFocus: menuItemBaseStyle$1.borderFocus,
                  block: menuItemBaseStyle$1.block,
                  hover: menuItemBaseStyle$1.hover,
                  display: menuItemBaseStyle$1.display,
                  kind: menuItemBaseStyle$1.kind,
                  zIndex: menuItemBaseStyle$1.zIndex
                };
      case /* TopTeaser */4 :
          return makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, {
                      TAG: /* Gradient */3,
                      _0: /* LeftToRight */1
                    }, {
                      justifyContent: undefined,
                      alignItems: undefined,
                      autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceAvailable),
                      wrap: undefined,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* BackLink */5 :
          return makeStyle(Atom_Text_Ds.Papa.makeBacklink, undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
      case /* WeekSlider */6 :
          return makeStyle(undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S"))), undefined, undefined, undefined, {
                      TAG: /* Border */0,
                      _0: undefined
                    }, {
                      justifyContent: undefined,
                      alignItems: undefined,
                      autoSize: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, /* NoResizing */3, undefined, /* AllPlaceNeeded */1)),
                      wrap: /* OnOneLine */0,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* WeekSliderDownload */7 :
          return makeStyle(Atom_Text_Ds.Presse.makeGuideDownload, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      case /* WeekSliderTooltip */8 :
          return makeStyle(Atom_Text_Ds.Presse.makeWeekSliderTooltip, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeHorizontal("XXS"))), undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
      case /* NavPrev */9 :
          return makeNav("Left");
      case /* NavNext */10 :
          return makeNav("Right");
      
    }
  } else {
    switch (style.TAG | 0) {
      case /* MenuItem */0 :
          if (style._0) {
            return menuItemBaseStyle$1;
          } else {
            return {
                    textStyle: Atom_Text_Ds.Presse.menuItemCurrent,
                    background: Particle_Background_Ds.white,
                    spacer: menuItemBaseStyle$1.spacer,
                    border: menuItemBaseStyle$1.border,
                    shape: menuItemBaseStyle$1.shape,
                    borderFocus: menuItemBaseStyle$1.borderFocus,
                    block: menuItemBaseStyle$1.block,
                    hover: {
                      TAG: /* Dash */4,
                      _0: "White",
                      _1: "M"
                    },
                    display: menuItemBaseStyle$1.display,
                    kind: menuItemBaseStyle$1.kind,
                    zIndex: menuItemBaseStyle$1.zIndex
                  };
          }
      case /* MenuItemChild */1 :
          return {
                  textStyle: menuItemBaseStyle$1.textStyle,
                  background: makeBackgroundByHighlight$1(style._0),
                  spacer: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("S", "M", undefined)),
                  border: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, /* PresseMenuItemChild */22, undefined, undefined, /* None */19)),
                  shape: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* Rectangle */0),
                  borderFocus: menuItemBaseStyle$1.borderFocus,
                  block: {
                    justifyContent: "flexStart",
                    alignItems: undefined,
                    autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceAvailable),
                    wrap: /* OnOneLine */0,
                    alignSelf: undefined,
                    position: undefined,
                    overflow: undefined
                  },
                  hover: undefined,
                  display: menuItemBaseStyle$1.display,
                  kind: menuItemBaseStyle$1.kind,
                  zIndex: menuItemBaseStyle$1.zIndex
                };
      case /* MenuItemWithChilds */2 :
          return {
                  textStyle: Atom_Text_Ds.Presse.makeMenuItemWithChilds(style._0),
                  background: makeBackgroundByHighlight$1(style._1),
                  spacer: menuItemBaseStyle$1.spacer,
                  border: menuItemBaseStyle$1.border,
                  shape: menuItemBaseStyle$1.shape,
                  borderFocus: menuItemBaseStyle$1.borderFocus,
                  block: menuItemBaseStyle$1.block,
                  hover: menuItemBaseStyle$1.hover,
                  display: menuItemBaseStyle$1.display,
                  kind: menuItemBaseStyle$1.kind,
                  zIndex: menuItemBaseStyle$1.zIndex
                };
      case /* Outline */3 :
          var disabled = style._0;
          return makeStyle(Atom_Text_Ds.makeSecondaryCta, Caml_option.some(disabled ? Particle_Background_Ds.Presse.disabledButton : Particle_Background_Ds.transparent), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S"))), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                  TAG: /* Textfield */7,
                                  _0: /* Inactive */1
                                }))), undefined, undefined, Caml_option.some(disabled ? /* NotAllowed */4 : ({
                              TAG: /* Border */0,
                              _0: {
                                TAG: /* Textfield */7,
                                _0: /* Active */0
                              }
                            })), undefined, undefined, undefined, undefined, undefined);
      case /* SearchButton */4 :
          return {
                  textStyle: Atom_Text_Ds.Presse.makeSearchButton(style._0),
                  background: Particle_Background_Ds.transparent,
                  spacer: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XS", "XS", undefined)),
                  border: menuItemBaseStyle$1.border,
                  shape: menuItemBaseStyle$1.shape,
                  borderFocus: menuItemBaseStyle$1.borderFocus,
                  block: undefined,
                  hover: /* Scale */3,
                  display: menuItemBaseStyle$1.display,
                  kind: menuItemBaseStyle$1.kind,
                  zIndex: menuItemBaseStyle$1.zIndex
                };
      case /* SelectDay */5 :
          var match = style._0 ? [
              Particle_Background_Ds.transparent,
              {
                TAG: /* Border */0,
                _0: undefined
              }
            ] : [
              Particle_Background_Ds.primary,
              /* CursorDefault */0
            ];
          return makeStyle(undefined, Caml_option.some(match[0]), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeVertical("S")), undefined, undefined, Particle_Spacer_Ds.makeVertical("XS"))), undefined, undefined, undefined, Caml_option.some(match[1]), {
                      justifyContent: undefined,
                      alignItems: undefined,
                      autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceNeeded),
                      wrap: /* OnOneLine */0,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      
    }
  }
}

var Presse = {
  menuItemBaseStyle: menuItemBaseStyle$1,
  makeBackgroundByHighlight: makeBackgroundByHighlight$1,
  makeNav: makeNav,
  make: make$11
};

function make$12(style) {
  if (typeof style === "number") {
    switch (style) {
      case /* Base */0 :
          return makeStyle(Atom_Text_Ds.Mona.makeCta, Caml_option.some(Particle_Background_Ds.white), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S"))), undefined, undefined, undefined, /* Opacity */5, undefined, undefined, undefined, undefined, undefined);
      case /* FooterLink */2 :
          return makeStyle(Atom_Text_Ds.Mona.makeFooterLink, undefined, undefined, undefined, undefined, undefined, /* Opacity */5, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.inlineFlex)), undefined, undefined, undefined);
      case /* Link */1 :
      case /* ButtonWithLinkStyle */3 :
          break;
      case /* Dropdown */4 :
          return makeStyle(Atom_Text_Ds.Mona.makeDropdown, Caml_option.some(Particle_Background_Ds.dropdownMenu), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S"))), undefined, undefined, undefined, Caml_option.some(undefined), {
                      justifyContent: undefined,
                      alignItems: undefined,
                      autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceAvailable),
                      wrap: /* OnOneLine */0,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* Disabled */5 :
          return makeStyle(Atom_Text_Ds.Mona.makeDefault, Caml_option.some(Particle_Background_Ds.disabledButtonMona), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S"))), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                  TAG: /* Cta */2,
                                  _0: /* Inactive */1,
                                  _1: "Medium"
                                }))), undefined, undefined, /* NotAllowed */4, undefined, undefined, undefined, undefined, undefined);
      case /* EventLink */6 :
          return makeStyle(Atom_Text_Ds.Mona.makeEventLink, undefined, undefined, Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* EventInfoLink */14))), undefined, undefined, /* Opacity */5, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.inlineFlex)), undefined, undefined, undefined);
      
    }
  } else {
    switch (style.TAG | 0) {
      case /* Outline */0 :
          var disabled = style._0;
          return makeStyle(Atom_Text_Ds.makeSecondaryCta, Caml_option.some(disabled ? Particle_Background_Ds.disabledButtonMona : Particle_Background_Ds.transparent), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S"))), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                  TAG: /* Textfield */7,
                                  _0: /* Inactive */1
                                }))), undefined, undefined, Caml_option.some(disabled ? /* NotAllowed */4 : /* Opacity */5), undefined, undefined, undefined, undefined, undefined);
      case /* ProfileNavigationItemList */1 :
          var state = style._0;
          return makeStyle(Atom_Text_Ds.Mona.profileNavigationItemList, Caml_option.some(state ? Particle_Background_Ds.transparent : Particle_Background_Ds.userNavigationItemListCurrentMona), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeVerticalAndHorizontal("XS", "L", undefined)), undefined, undefined, Particle_Spacer_Ds.makeAll("S"))), undefined, undefined, undefined, Caml_option.some(state ? ({
                              TAG: /* Background */2,
                              _0: "DarkGrey"
                            }) : undefined), {
                      justifyContent: undefined,
                      alignItems: undefined,
                      autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceAvailable),
                      wrap: undefined,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* HeaderNavigationItemList */2 :
          return makeStyle(Atom_Text_Ds.Mona.makeHeaderNavigationItemList(style._0), undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
      case /* HeaderSecondaryNavigationItemList */3 :
          return makeStyle(Atom_Text_Ds.Mona.makeHeaderSecondaryNavigationItemList(style._0), undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
      
    }
  }
  return makeStyle(Atom_Text_Ds.Mona.makeLink, undefined, undefined, undefined, undefined, undefined, /* Opacity */5, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.inlineFlex)), undefined, undefined, undefined);
}

var Mona = {
  make: make$12
};

function make$13(style) {
  if (style) {
    return makeStyle(Atom_Text_Ds.AndroidReleases.makeCtaDownload, undefined, Caml_option.some(particleSpacerVerticalSmaller), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* AndroidRealeaseCtaDownload */1))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    return makeStyle(Atom_Text_Ds.AndroidReleases.makeHeroTutorialButton, Caml_option.some(Particle_Background_Ds.AndroidReleases.ctaTutorial), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XS", "M", undefined))), undefined, undefined, undefined, {
                TAG: /* Background */2,
                _0: "LightGrey"
              }, {
                justifyContent: "center",
                alignItems: "center",
                autoSize: undefined,
                wrap: /* OnOneLine */0,
                alignSelf: undefined,
                position: undefined,
                overflow: undefined
              }, undefined, undefined, undefined, undefined);
  }
}

var AndroidReleases = {
  make: make$13
};

function make$14(style) {
  if (style) {
    return makeStyle(Atom_Text_Ds.makeTos({
                    NAME: "Cta",
                    VAL: "Default"
                  }), undefined, undefined, undefined, Caml_option.some(shapeControl), undefined, /* Opacity */5, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.inline)), undefined, undefined, undefined);
  } else {
    return makeStyle(Atom_Text_Ds.NewsletterZone.cta, Caml_option.some(Particle_Background_Ds.white), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S"))), undefined, undefined, undefined, /* Opacity */5, {
                justifyContent: "center",
                alignItems: undefined,
                autoSize: Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, /* MaxContent */2, undefined, undefined, /* AllPlaceAvailable */0)),
                wrap: /* OnOneLine */0,
                alignSelf: undefined,
                position: undefined,
                overflow: undefined
              }, undefined, undefined, undefined, undefined);
  }
}

var NewsletterZone = {
  make: make$14
};

var backLink = makeStyle(Atom_Text_Ds.Papa.makeBacklink, undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);

var Papa = {
  backLink: backLink
};

var closeSize = Particle_Screen_Ds.make(undefined, undefined, undefined, Type_Header.Constants.height.m, undefined, Type_Header.Constants.height.default);

function make$15(style) {
  switch (style) {
    case /* Cta */0 :
        return makeStyle(Atom_Text_Ds.Player.cta, Caml_option.some(Particle_Background_Ds.white), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("S"))), undefined, undefined, undefined, /* Opacity */5, undefined, undefined, undefined, undefined, undefined);
    case /* Link */1 :
        return makeStyle(Atom_Text_Ds.Player.link, undefined, undefined, undefined, undefined, undefined, /* Opacity */5, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.inlineFlex)), undefined, undefined, undefined);
    case /* CloseOverlay */2 :
        return makeStyle(Atom_Text_Ds.Header.make({
                        NAME: "Cta",
                        VAL: "Default"
                      }, {
                        TAG: /* Icon */1,
                        _0: {
                          position: /* Alone */0,
                          icon: "MenuClose",
                          size: Particle_Screen_Ds.make(undefined, undefined, undefined, "L", undefined, "S")
                        }
                      }, undefined), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("None"))), undefined, Caml_option.some(Particle_Screen_Ds.map((function (value) {
                              return {
                                      TAG: /* Square */2,
                                      _0: value
                                    };
                            }), closeSize)), undefined, undefined, {
                    justifyContent: "center",
                    alignItems: "center",
                    autoSize: undefined,
                    wrap: /* OnOneLine */0,
                    alignSelf: "center",
                    position: undefined,
                    overflow: undefined
                  }, undefined, undefined, undefined, undefined);
    case /* CloseTooltip */3 :
        return makeStyle(Atom_Text_Ds.Header.make({
                        NAME: "Cta",
                        VAL: "Default"
                      }, {
                        TAG: /* Icon */1,
                        _0: {
                          position: /* Alone */0,
                          icon: "MenuClose",
                          size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "S")
                        }
                      }, undefined), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("None"))), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                            TAG: /* Square */2,
                            _0: Type_Header.Constants.height.default
                          })), undefined, undefined, {
                    justifyContent: "center",
                    alignItems: "center",
                    autoSize: undefined,
                    wrap: /* OnOneLine */0,
                    alignSelf: "center",
                    position: undefined,
                    overflow: undefined
                  }, undefined, undefined, undefined, undefined);
    case /* PlayOverlayButton */4 :
        return makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
    case /* WarningCta */5 :
        return makeStyle(Atom_Text_Ds.Player.warningCta, Caml_option.some(Particle_Background_Ds.white), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeAll("S")), undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XXS", "XS", undefined))), undefined, undefined, undefined, /* Opacity */5, undefined, undefined, undefined, undefined, undefined);
    case /* WarningSecondaryCta */6 :
        return makeStyle(Atom_Text_Ds.Player.warningSecondaryCta, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeAll("S")), undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XXS", "XS", undefined))), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                TAG: /* Textfield */7,
                                _0: /* Inactive */1
                              }))), undefined, undefined, /* Opacity */5, undefined, undefined, undefined, undefined, undefined);
    case /* WarningLink */7 :
        return makeStyle(Atom_Text_Ds.Player.warningLink, undefined, undefined, undefined, undefined, undefined, /* Opacity */5, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.inlineFlex)), undefined, undefined, undefined);
    
  }
}

var Player = {
  closeSize: closeSize,
  make: make$15
};

function make$16(style, variation) {
  if (style) {
    if (variation === 1) {
      return makeStyle(Curry._1(topTeaserButtons_textStyleDisabled, {
                      TAG: /* Icon */1,
                      _0: {
                        position: {
                          TAG: /* Left */0,
                          _0: innerSpace
                        },
                        icon: "Play",
                        size: topTeaserButtons_iconSize
                      }
                    }), undefined, Caml_option.some(topTeaserButtons_spacer), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                              TAG: /* Cta */2,
                              _0: /* Inactive */1,
                              _1: "Regular"
                            }))), Caml_option.some(topTeaserButtons_shape), undefined, /* NotAllowed */4, undefined, undefined, undefined, undefined, undefined);
    }
    if (variation === 0) {
      return makeStyle(Atom_Text_Ds.Trailer.programDisabled, undefined, Caml_option.some(particleSpacerVerticalSmaller), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                              TAG: /* Cta */2,
                              _0: /* Inactive */1,
                              _1: "Regular"
                            }))), undefined, undefined, /* NotAllowed */4, undefined, undefined, undefined, undefined, undefined);
    }
    
  } else {
    if (variation === 1) {
      return makeStyleLight({
                  TAG: /* Icon */1,
                  _0: {
                    position: {
                      TAG: /* Left */0,
                      _0: innerSpace
                    },
                    icon: "Play",
                    size: topTeaserButtons_iconSize
                  }
                });
    }
    if (variation === 0) {
      return makeStyle(Atom_Text_Ds.Trailer.programEnabled, undefined, Caml_option.some(particleSpacerVerticalSmaller), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                              TAG: /* Cta */2,
                              _0: /* Active */0,
                              _1: "Regular"
                            }))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    }
    
  }
  if (variation >= 3) {
    return makeStyle(Curry._1(Atom_Text_Ds.Teaser.Hover.toParent, Atom_Text_Ds.Teaser.Hover.trailerCta), undefined, Caml_option.some(particleSpacerVerticalSmaller), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* TeaserCta */28))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  } else {
    return makeStyle(Atom_Text_Ds.Trailer.eventZone, undefined, Caml_option.some(particleSpacerVerticalSmaller), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* EventZoneTrailer */15))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
  }
}

var Trailer = {
  make: make$16
};

var linkButton = makeStyle(Atom_Text_Ds.makeSetting({
          NAME: "Cta",
          VAL: "Active"
        }), Caml_option.some(Particle_Background_Ds.buttonSolid), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeVerticalAndHorizontal("M", "XL", undefined)), undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XS", "L", undefined))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);

var linkMessage = makeStyle(Atom_Text_Ds.makeSetting("MessageLink"), undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.inlineFlex)), undefined, undefined, undefined);

function make$17(variant) {
  switch (variant) {
    case /* Button */0 :
        return linkButton;
    case /* Message */1 :
        return linkMessage;
    case /* Dropdown */2 :
        return makeStyle(Atom_Text_Ds.Dropdown.current, undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
    
  }
}

var Setting = {
  linkButton: linkButton,
  linkMessage: linkMessage,
  make: make$17
};

var openSecurityCenter = makeStyle(Atom_Text_Ds.UserPref.makeSecurityCenter, undefined, Caml_option.some(particleSpacerVerticalSmaller), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                  TAG: /* Cta */2,
                  _0: /* Active */0,
                  _1: "Regular"
                }))), undefined, undefined, /* Opacity */5, undefined, undefined, undefined, undefined, undefined);

function make$18(style) {
  return openSecurityCenter;
}

var UserPref = {
  openSecurityCenter: openSecurityCenter,
  make: make$18
};

function make$19(x) {
  var exit = 0;
  if (typeof x === "number") {
    switch (x) {
      case /* AfterRight */0 :
          return makeStyle(Atom_Text_Ds.afterRight, undefined, undefined, undefined, undefined, undefined, undefined, {
                      justifyContent: undefined,
                      alignItems: "stretch",
                      autoSize: undefined,
                      wrap: undefined,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, CssJs.inlineFlex)), undefined, undefined, undefined);
      case /* BackHome404 */1 :
          return makeStyle(Atom_Text_Ds.Oops.make404cta, Caml_option.some(Particle_Background_Ds.Oops.cta404), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XXS", "M", undefined))), undefined, undefined, undefined, {
                      TAG: /* Border */0,
                      _0: undefined
                    }, undefined, undefined, undefined, undefined, undefined);
      case /* BackHome500 */2 :
          return makeStyle(Atom_Text_Ds.Oops.make500cta, undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
      case /* BackLink */3 :
          return makeStyle(Atom_Text_Ds.makeContentCollection({
                          NAME: "Cta",
                          VAL: "Default"
                        }), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeTop("XS"))), undefined, undefined, undefined, /* Opacity */5, undefined, undefined, undefined, undefined, undefined);
      case /* Banner */4 :
          return makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, {
                      TAG: /* Color */1,
                      _0: "White"
                    }, {
                      justifyContent: undefined,
                      alignItems: undefined,
                      autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceAvailable),
                      wrap: undefined,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* Breadcrumb */5 :
      case /* Broadcast */6 :
          exit = 2;
          break;
      case /* BuyProgram */7 :
          return makeStyle(Atom_Text_Ds.ProgramContent.makeBuyProgramLink, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeRight("S")), undefined, Particle_Spacer_Ds.makeRight("L"))), undefined, undefined, undefined, /* Opacity */5, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "inlineFlex")), undefined, undefined, undefined);
      case /* CategoryTeaser */8 :
          return makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, {
                      TAG: /* Color */1,
                      _0: "White"
                    }, undefined, undefined, undefined, undefined, undefined);
      case /* Dropdown */9 :
          return makeStyle(Atom_Text_Ds.Dropdown.current, undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
      case /* DropdownItem */10 :
          return makeStyle(Atom_Text_Ds.Dropdown.listItem, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XS", "L", undefined))), undefined, undefined, undefined, {
                      TAG: /* Color */1,
                      _0: "LightGrey"
                    }, undefined, undefined, undefined, undefined, undefined);
      case /* ExternalLink */11 :
          return makeStyle(Atom_Text_Ds.makeExternal({
                          NAME: "Cta",
                          VAL: "Default"
                        }), undefined, undefined, undefined, undefined, undefined, {
                      TAG: /* Color */1,
                      _0: "White"
                    }, {
                      justifyContent: undefined,
                      alignItems: undefined,
                      autoSize: undefined,
                      wrap: /* OnOneLine */0,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* MenuBrandLogo */12 :
          return makeStyle(Atom_Text_Ds.Header.make({
                          NAME: "Cta",
                          VAL: "Default"
                        }, {
                          TAG: /* Logo */0,
                          _0: {
                            position: /* Alone */0,
                            logo: {
                              NAME: "ArteVerticalLogo",
                              VAL: "Header"
                            }
                          }
                        }, undefined), Caml_option.some(Particle_Background_Ds.transparent), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.make("Zero", "Zero", "Zero", "XXS", undefined)), undefined, undefined, Particle_Spacer_Ds.makeHorizontal("XXS"))), undefined, undefined, undefined, {
                      TAG: /* Color */1,
                      _0: "White"
                    }, {
                      justifyContent: undefined,
                      alignItems: "center",
                      autoSize: undefined,
                      wrap: /* OnOneLine */0,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "inlineFlex")), undefined, undefined, undefined);
      case /* Papa */14 :
          return backLink;
      case /* PlayNextSimple */15 :
          return makeStyle(Atom_Text_Ds.PlayNextSimple.makeTitle, undefined, undefined, undefined, undefined, undefined, /* Underline */1, undefined, undefined, undefined, undefined, undefined);
      case /* ProgramExternal */16 :
          return makeStyle(Atom_Text_Ds.ProgramExternal.make({
                          NAME: "Cta",
                          VAL: "Default"
                        }), undefined, undefined, undefined, undefined, undefined, /* Underline */1, {
                      justifyContent: undefined,
                      alignItems: undefined,
                      autoSize: undefined,
                      wrap: /* OnOneLine */0,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* ProgramMetaGenre */17 :
          return makeStyle(Atom_Text_Ds.ProgramContent.makeValueGenre, undefined, undefined, undefined, undefined, undefined, /* Opacity */5, undefined, undefined, undefined, undefined, undefined);
      case /* SearchNoResultsAdvice */18 :
          return makeStyle(Atom_Text_Ds.listItemUnderline, undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
      case /* SeeLessExpanderButton */19 :
          return makeStyle(Atom_Text_Ds.makeExpanderButton("Top"), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeTop("S"))), undefined, undefined, undefined, /* Opacity */5, {
                      justifyContent: undefined,
                      alignItems: undefined,
                      autoSize: undefined,
                      wrap: undefined,
                      alignSelf: "flexStart",
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* SeeMore */20 :
          return makeStyle(undefined, Caml_option.some(Particle_Background_Ds.buttonSolid), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("S", "S", undefined))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      case /* SeeMoreExpanderButton */21 :
          return makeStyle(Atom_Text_Ds.makeExpanderButton("Down"), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeTop("S"))), undefined, undefined, undefined, /* Opacity */5, {
                      justifyContent: undefined,
                      alignItems: undefined,
                      autoSize: undefined,
                      wrap: undefined,
                      alignSelf: "flexStart",
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* Seo */22 :
          return makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, /* Seo */1, undefined, undefined);
      case /* Partner */13 :
      case /* StoreButton */23 :
          exit = 1;
          break;
      case /* Subscribe */24 :
          return makeStyle(Atom_Text_Ds.makeSecondaryCtaWithAsset({
                          TAG: /* Icon */1,
                          _0: {
                            position: {
                              TAG: /* Left */0,
                              _0: innerSpace
                            },
                            icon: "Plus",
                            size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
                          }
                        }), undefined, Caml_option.some(particleSpacerVerticalSmaller), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                  TAG: /* Cta */2,
                                  _0: /* Active */0,
                                  _1: "Regular"
                                }))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      case /* Tag */25 :
          return makeStyle(Atom_Text_Ds.Sticker.tag, Caml_option.some(Particle_Background_Ds.tags), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeVerticalAndHorizontal("XS", "S", undefined))), undefined, undefined, undefined, /* Opacity */5, undefined, undefined, undefined, undefined, undefined);
      case /* Teaser */26 :
          return makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), {
                      justifyContent: undefined,
                      alignItems: "flexStart",
                      autoSize: undefined,
                      wrap: undefined,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, Caml_option.some(undefined), undefined);
      case /* TeaserLandscapeGenre */27 :
          return makeStyle(undefined, undefined, undefined, Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                  TAG: /* TeaserGenre */6,
                                  _0: "Concert",
                                  _1: /* Inactive */1
                                }))), undefined, undefined, {
                      TAG: /* Border */0,
                      _0: {
                        TAG: /* TeaserGenre */6,
                        _0: "Concert",
                        _1: /* Active */0
                      }
                    }, {
                      justifyContent: undefined,
                      alignItems: "flexStart",
                      autoSize: undefined,
                      wrap: undefined,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, Caml_option.some(undefined), undefined);
      case /* TeaserHoverClose */28 :
      case /* TeaserMoreOptions */29 :
          exit = 3;
          break;
      case /* TeaserGenre */30 :
          return makeStyle(Curry._1(Atom_Text_Ds.Teaser.Hover.toParent, Atom_Text_Ds.Teaser.Hover.genreLink), undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
      case /* TeaserInfo */31 :
          return makeStyle(undefined, undefined, undefined, undefined, undefined, /* TeaserInfoAccessibility */29, Caml_option.some(undefined), undefined, undefined, undefined, Caml_option.some(undefined), undefined);
      case /* TopBanner */32 :
          return makeStyle(Atom_Text_Ds.makeTopBanner({
                          NAME: "Cta",
                          VAL: "Default"
                        }), undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
      case /* Unsubscribe */33 :
          return makeStyle(Atom_Text_Ds.makeSecondaryCtaWithAsset({
                          TAG: /* Icon */1,
                          _0: {
                            position: {
                              TAG: /* Left */0,
                              _0: innerSpace
                            },
                            icon: "CloseWithBackground",
                            size: Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, "XXS")
                          }
                        }), undefined, Caml_option.some(particleSpacerVerticalSmaller), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                                  TAG: /* Cta */2,
                                  _0: /* Active */0,
                                  _1: "Regular"
                                }))), undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined);
      case /* SiteMap */34 :
          return makeStyle(Atom_Text_Ds.SiteMap.link, undefined, undefined, undefined, undefined, undefined, {
                      TAG: /* Color */1,
                      _0: "Arte"
                    }, undefined, undefined, undefined, undefined, undefined);
      
    }
  } else {
    switch (x.TAG | 0) {
      case /* AndroidReleases */0 :
          return make$13(x._0);
      case /* Carousel */1 :
          return make$4(x._0);
      case /* ColoredBox */2 :
          return makeStyle(undefined, Caml_option.some(x._0), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, Particle_Spacer_Ds.makeAll("XS"))), undefined, undefined, undefined, {
                      TAG: /* Border */0,
                      _0: undefined
                    }, {
                      justifyContent: "flexStart",
                      alignItems: "center",
                      autoSize: undefined,
                      wrap: /* OnOneLine */0,
                      alignSelf: "flexStart",
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* Corporate */3 :
          return make$10(x._0);
      case /* DownloadLink */4 :
          return makeStyle(Atom_Text_Ds.makeDownload(x._1, undefined), undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, x._0)), undefined, undefined, undefined, /* Opacity */5, {
                      justifyContent: undefined,
                      alignItems: undefined,
                      autoSize: undefined,
                      wrap: /* OnOneLine */0,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* EventZone */5 :
          return make$8(x._0);
      case /* Favorite */6 :
          return make$7(x._0, x._1);
      case /* Footer */7 :
          return make$3(x._0);
      case /* GenreSelect */8 :
          return make$9(x._0);
      case /* GuideTvCalendar */9 :
          var match = x._0 ? [
              Particle_Background_Ds.transparent,
              {
                TAG: /* Border */0,
                _0: undefined
              }
            ] : [
              Particle_Background_Ds.primary,
              /* CursorDefault */0
            ];
          return makeStyle(undefined, Caml_option.some(match[0]), Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, Caml_option.some(Particle_Spacer_Ds.makeVertical("S")), undefined, undefined, Particle_Spacer_Ds.makeVertical("XS"))), undefined, undefined, undefined, Caml_option.some(match[1]), {
                      justifyContent: undefined,
                      alignItems: undefined,
                      autoSize: Caml_option.some(Particle_Screen_Constants.autoSizeAllPlaceAvailable),
                      wrap: undefined,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* Header */10 :
          return make$1(x._0);
      case /* Message */11 :
          return make(x._0);
      case /* Mona */12 :
          return make$12(x._0);
      case /* NewsletterZone */13 :
          return make$14(x._0);
      case /* NextEpisode */14 :
          return makeStyleWatch(x._0, "Play", Particle_Background_Ds.buttonSolid);
      case /* Player */15 :
          return make$15(x._0);
      case /* Presse */16 :
          return make$11(x._0);
      case /* Setting */17 :
          return make$17(x._0);
      case /* Sharebar */18 :
          return make$2(x._0);
      case /* Slider */19 :
          return make$5(x._0);
      case /* TeaserPlay */20 :
          return makeTeaserHoverPlay(x._0, x._1);
      case /* TeaserGuide */21 :
          return make$6(x._0);
      case /* ThemeSwitchButton */22 :
          return makeStyle(Atom_Text_Ds.makeThemeSwitchButton(x._0), Caml_option.some(Particle_Background_Ds.themeSwitch), undefined, undefined, Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, {
                              TAG: /* Square */2,
                              _0: Type_Header.Constants.height.m
                            })), undefined, Caml_option.some(undefined), {
                      justifyContent: "center",
                      alignItems: "center",
                      autoSize: undefined,
                      wrap: undefined,
                      alignSelf: undefined,
                      position: undefined,
                      overflow: undefined
                    }, undefined, undefined, undefined, undefined);
      case /* TopTeaser */23 :
          return makeStyleWatch(x._0, "Play", Particle_Background_Ds.buttonSolid);
      case /* Trailer */24 :
          return make$16(x._0, x._1);
      case /* UserPref */25 :
          return openSecurityCenter;
      
    }
  }
  switch (exit) {
    case 1 :
    case 2 :
        return makeStyle(undefined, undefined, undefined, undefined, undefined, undefined, Caml_option.some(undefined), undefined, undefined, undefined, undefined, undefined);
    case 3 :
        return makeStyle(Curry._1(Atom_Text_Ds.Teaser.Hover.toParent, Curry._2(Atom_Text_Ds.Teaser.Hover.cta, undefined, undefined)), undefined, Caml_option.some(topTeaserButtons_spacer), Caml_option.some(Caml_option.some(Particle_Screen_Ds.make(undefined, undefined, undefined, undefined, undefined, /* TeaserCta */28))), Caml_option.some(topTeaserButtons_shape), undefined, undefined, undefined, undefined, undefined, undefined, undefined);
    
  }
}

function shapeToParticleShape(shape) {
  if (typeof shape === "number") {
    return {
            TAG: /* Rectangle */0,
            _0: /* Auto */0
          };
  }
  switch (shape.TAG | 0) {
    case /* RectangleWithStaticHeight */0 :
        return {
                TAG: /* Rectangle */0,
                _0: {
                  TAG: /* Height */0,
                  _0: shape._0
                }
              };
    case /* Circle */1 :
        return {
                TAG: /* Circle */1,
                _0: shape._0
              };
    case /* Square */2 :
        return {
                TAG: /* Square */2,
                _0: shape._0
              };
    
  }
}

function view(param) {
  return {
          block: param.block,
          textStyle: param.textStyle,
          background: param.background,
          spacer: param.spacer,
          border: param.border,
          borderFocus: param.borderFocus,
          shape: Particle_Screen_Ds.map(shapeToParticleShape, param.shape),
          hover: param.hover,
          display: param.display,
          kind: param.kind,
          zIndex: param.zIndex
        };
}

var topTeaserButtonHeight = 40;

exports.getPredefinedHeight = getPredefinedHeight;
exports.getPredefinedWidth = getPredefinedWidth;
exports.innerSpace = innerSpace;
exports.spacerVerticalSmaller = spacerVerticalSmaller;
exports.particleSpacerVerticalSmaller = particleSpacerVerticalSmaller;
exports.particleSpacerVerticalSmallerWithMedValue = particleSpacerVerticalSmallerWithMedValue;
exports.topTeaserButtonHeight = topTeaserButtonHeight;
exports.topTeaserButtons = topTeaserButtons;
exports.makeStyle = makeStyle;
exports.makeTeaserHoverPlay = makeTeaserHoverPlay;
exports.makeStyleWatch = makeStyleWatch;
exports.makeStyleLight = makeStyleLight;
exports.Message = Message;
exports.Header = Header;
exports.Sharebar = Sharebar;
exports.Footer = Footer;
exports.shapeArrow = shapeArrow;
exports.shapeControl = shapeControl;
exports.Carousel = Carousel;
exports.Slider = Slider;
exports.TeaserGuide = TeaserGuide;
exports.Favorite = Favorite;
exports.EventZone = EventZone;
exports.GenreSelect = GenreSelect;
exports.Corporate = Corporate;
exports.Presse = Presse;
exports.Mona = Mona;
exports.AndroidReleases = AndroidReleases;
exports.NewsletterZone = NewsletterZone;
exports.Papa = Papa;
exports.Player = Player;
exports.Trailer = Trailer;
exports.Setting = Setting;
exports.UserPref = UserPref;
exports.make = make$19;
exports.shapeToParticleShape = shapeToParticleShape;
exports.view = view;
/* innerSpace Not a pure module */
